module.exports = __webpack_public_path__ + "media/images/segment_engineer_static-6207003c81479ee7c9eae4a9d8e030dc.svg";